import React, { Component } from "react";

import {
  Wrapper,
  Title,
  Copy,
  Bold,
  ExternalImage
} from "app/NativeComponents/common";

class Feature extends Component {
  renderImage(feature) {
    if (feature.image) {
      return (
        <Wrapper style={{ marginBottom: 20 }}>
          <ExternalImage
            style={{
              resizeMode: "contain",
              width: 60,
              height: 60
            }}
            contain={true}
            image={feature.image ? feature.image.fields.file.url : ""}
          />
        </Wrapper>
      );
    }
  }

  renderTitle(feature) {
    if (this.props.small) {
      return (
        <Copy style={{ textAlign: "center" }}>
          <Bold>{feature.title}</Bold>
        </Copy>
      );
    }
    return (
      <Title style={{ marginBottom: 10, textAlign: "center" }}>
        {feature.title}
      </Title>
    );
  }

  render() {
    const { feature } = this.props;
    if (feature) {
      return (
        <Wrapper
          style={{
            padding: 20,
            width: this.props.isMobile ? "100%" : 160,
            alignItems: "center",
            justifyContent: "space-between"
          }}
        >
          {this.renderImage(feature)}
          {this.renderTitle(feature)}
          <Copy style={{ textAlign: "center" }}>{feature.description}</Copy>
        </Wrapper>
      );
    }

    return <Wrapper />;
  }
}
export default Feature;
